import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { IconButton } from '@pets-ui/IconButton/IconButton'
import { CloseSmall, Search } from '@pets-ui/icons'
import { Input } from '@pets-ui/Input/Input'
import { Select } from '@pets-ui/Select/Select'
import { SelectOption } from '@pets-ui/SelectOption/SelectOption'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { type KeyboardEvent } from 'react'
import { SEARCH_FIELD_OPTIONS, type SearchFieldType } from '../hooks/use-order-search'

interface OrderSearchInputProps {
  searchKeyword: string
  searchField: SearchFieldType
  onKeywordChange: (keyword: string) => void
  onFieldChange: (field: SearchFieldType) => void
  onSearch: () => void
  onClearKeyword: () => void
}

const styles = stylex.create({
  selectTrigger: {
    borderWidth: 0,
  },
  selectPaper: {
    borderWidth: 0,
    boxShadow: '0px 4px 6px rgba(0,0,0,0.08)',
  },
  inputBase: {
    padding: 0,
    borderWidth: 0,
  },
})

const inputXStyles = {
  inputBase: {
    root: styles.inputBase,
  },
}

const selectXStyles = {
  select: styles.selectTrigger,
  paper: styles.selectPaper,
}

export const OrderSearchInput = ({
  searchKeyword,
  searchField,
  onKeywordChange,
  onFieldChange,
  onSearch,
  onClearKeyword,
}: OrderSearchInputProps) => {
  const handleInputKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onSearch()
    }
  }

  return (
    <HStack
      width="fit-content"
      alignItems="center"
      backgroundColor={colors.white}
      borderColor={colors.grey300}
      borderWidth={1}
      borderRadius={4}
    >
      <Select
        value={searchField}
        onChange={onFieldChange}
        xStyles={selectXStyles}
      >
        {SEARCH_FIELD_OPTIONS.map(option => (
          <SelectOption key={option.value} value={option.value}>
            {option.label}
          </SelectOption>
        ))}
      </Select>
      <Input
        value={searchKeyword}
        onChange={event => onKeywordChange(event.target.value)}
        onKeyDown={handleInputKeyDown}
        placeholder="請輸入"
        xStyles={inputXStyles}
        startAdornment={<Box width={1} height={16} backgroundColor={colors.grey300} mr={2} />}
        endAdornment={(
          <HStack alignItems="center" pr={1}>
            {searchKeyword && (
              <IconButton onClick={onClearKeyword} size="small" aria-label="清除搜尋內容">
                <CloseSmall fontSize={20} color={colors.grey500} />
              </IconButton>
            )}
            <IconButton onClick={onSearch} size="small" aria-label="執行搜尋">
              <Search fontSize={20} color={colors.grey500} />
            </IconButton>
          </HStack>
        )}
      />
    </HStack>
  )
}
